import { cx } from "../../lib/cx.js";
import { Icon } from "../Icon/Icon.js";
import { useOptionalBrand } from "../ThemeRoot/BrandContext.js";
import { BrandMark } from "../BrandMark/BrandMark.js";
import { StatusDot } from "../StatusDot/StatusDot.js";
/* empty css               */
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/components/AuthLayout/AuthLayout.tsx
/**
* The sign-in page frame: an optional secure-host strip, a centred card with the brand,
* heading, subtitle, body and footnote, and a bottom bar. Slots only; no data fetching.
*/
function AuthLayout({ host, brand, title, subtitle, children, footnote, footer, fill = true, className, ...rest }) {
	const config = useOptionalBrand();
	const shownHost = host === void 0 ? config?.secureHost : host;
	const shownBrand = brand === void 0 && config ? /* @__PURE__ */ jsx(BrandMark, {
		size: "lg",
		showName: !config.logo
	}) : brand;
	return /* @__PURE__ */ jsxs("div", {
		className: cx("ds-auth-layout", fill && "ds-auth-layout--fill", className),
		...rest,
		children: [
			shownHost && /* @__PURE__ */ jsx("header", {
				className: "ds-auth-layout__strip",
				children: /* @__PURE__ */ jsx(StatusDot, {
					tone: "success",
					children: shownHost
				})
			}),
			/* @__PURE__ */ jsx("main", {
				className: "ds-auth-layout__center",
				children: /* @__PURE__ */ jsxs("div", {
					className: "ds-auth-layout__card",
					children: [
						shownBrand && /* @__PURE__ */ jsx("div", {
							className: "ds-auth-layout__brand",
							children: shownBrand
						}),
						/* @__PURE__ */ jsx("h1", {
							className: "ds-auth-layout__title",
							children: title
						}),
						subtitle && /* @__PURE__ */ jsx("p", {
							className: "ds-auth-layout__subtitle",
							children: subtitle
						}),
						children && /* @__PURE__ */ jsx("div", {
							className: "ds-auth-layout__body",
							children
						}),
						footnote && /* @__PURE__ */ jsxs("p", {
							className: "ds-auth-layout__footnote",
							children: [/* @__PURE__ */ jsx(Icon, {
								name: "lock",
								size: 13
							}), /* @__PURE__ */ jsx("span", { children: footnote })]
						})
					]
				})
			}),
			footer && /* @__PURE__ */ jsx("footer", {
				className: "ds-auth-layout__footer",
				children: footer
			})
		]
	});
}
//#endregion
export { AuthLayout };

//# sourceMappingURL=AuthLayout.js.map